import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

export interface ObjImage {
  image_name: string;
  image_url: string;
  category: string;
}

export interface DetailInformation {
  variety_name: string;
  meaning: string;
  synonyms: string;
  species: string;
  images: ObjImage[];


  variety_observation_id: string | null;
  observation_date: string | null;
  image_url_obs: string | null;

  user_id: string | null;
  username: string | null;
  image_url_usr: string | null;
  public_observation_count_usr: string | null;

  public_observation_count: number;

}

// =============== //

//A ------ //

//B ------ //
export interface Coordinates {
  latitude: number;
  longitude: number;
  location: string;
}
export interface NutritionalValue {
  text_1: number;
  text_2: string;
}
export interface InputValuesUsesInformation {
  adaptability: string | boolean;
  adaptability_img: string | boolean;
  aditional_information: string | boolean;
  coordinate_list: Coordinates[];
  cooking_time: string | boolean;
  culinary_uses: string | boolean;
  nutritional_list: NutritionalValue[] | boolean;
}

//C ------ //

export interface Info {
  descriptor_name: string;
  value: string;
}
export interface InputTemplate {
  main_icon: string | boolean;
  main_title: string | boolean;
  title: string | boolean;
  color: string;
  image: string | boolean;
  info_list: Info[];
}
@Component({
  selector: "app-detail-view",
  templateUrl: "./detail-view.component.html",
  styleUrls: ["./detail-view.component.css"],
})
export class DetailViewComponent implements OnInit {
  constructor(private router: Router,) {

  }

  // =============== //
  @Input() design!: string;
  @Input() type!: string;
  @Input() data!: any;
  @Input() images!: any;
  @Input() background_color!: string;
  @Input() myAngularxQrCode!: string;

  inputDetailInformation!: DetailInformation;
  indexImg!: number;
  mainImg!: string;
  //A ------ //

  inputValuesUsesInformation!: InputValuesUsesInformation;
  has_nutritional_list!: boolean;
  has_culinary_uses!: boolean;
  has_adaptability!: boolean;
  //C ------ //
  inputTemplate!: InputTemplate;

  //ALL ------ //
  viewType = "about";
  ngOnInit(): void {
    this.fnSetDetailInformation();
    this.fnSetInputValuesUsesInformation();
    this.fnSetInputTemplate();
  }

  // fnChangeImageIndex(eventData: { _imgIndex: number }) {
  //   this.indexImg = eventData._imgIndex;
  //   this.mainImg = this.images[this.indexImg].image_url;
  // }

  fnSetDetailInformation() {
    if (this.type == "detail_information") {
      this.images.length
        ? 1
        : (this.images = [
          {
            image_url:
              "https://wikipapa.org/images/img-no-disponible-large.jpg",
          },
        ]);

      this.indexImg = 0;
      const _variety_name = this.data.data_1.variety_name;
      const _meaning = this.data.data_2.meaning;
      const _synonyms = this.data.data_3.synonyms;
      const _species = this.data.data_4.species_name;
      const _images = this.images;



      // if (this.data.data_5) {
      const _variety_observation_id = this.data.data_5?.variety_observation_id;
      const _observation_date = this.data.data_5?.observation_date;
      const _image_url_obs = this.data.data_5?.image_url;
      // } else {
      //   const _variety_observation_id = this.data.data_5.variety_observation_id
      //   const _observation_date = this.data.data_5.observation_date
      //   const _image_url_obs = this.data.data_5.image_url
      // }

      // if (this.data.data_6) {
      const _user_id = this.data.data_6?.user_id;
      const _username = this.data.data_6?.username;
      const _image_url_usr = this.data.data_6?.image_url;
      const _public_observation_count_usr = this.data.data_6?.public_observation_count;
      // } else {
      //   const _user_id = this.data.data_6.user_id
      //   const _username = this.data.data_6.username
      //   const _image_url_usr = this.data.data_6.image_url
      // }

      const _public_observation_count = this.data.data_7

      this.mainImg = this.images[this.indexImg].image_url;
      this.inputDetailInformation = {
        variety_name: _variety_name,
        meaning: _meaning,
        synonyms: _synonyms,
        species: _species,
        images: _images,

        user_id: _user_id,
        username: _username ? _username : 'No hay usuario',
        image_url_usr: _image_url_usr,
        public_observation_count_usr: _public_observation_count_usr ? _public_observation_count_usr : 'No hay datos',

        variety_observation_id: _variety_observation_id,
        observation_date: _observation_date ? _observation_date : 'Sin fecha',
        image_url_obs: _image_url_obs,

        public_observation_count: _public_observation_count,
      };
    }
  }

  fnSetInputValuesUsesInformation() {
    if (this.type == "values_uses_information") {
      const _adaptability_aux_1 = this.data.data_2.filter(
        (x: any) => x.descriptor_id == 46
      )[0]?.value;
      const _adaptability_aux_2 = parseInt(
        _adaptability_aux_1?.substring(0, 4)
      );

      let _adaptability_img: string;
      switch (true) {
        case _adaptability_aux_2 < 1000:
          _adaptability_img =
            "url(https://wikipapa.org/images/pisos-altitudinales-0-1000.png)";
          break;
        case _adaptability_aux_2 < 2000:
          _adaptability_img =
            "url(https://wikipapa.org/images/pisos-altitudinales-1000-2000.png)";
          break;
        case _adaptability_aux_2 < 3000:
          _adaptability_img =
            "url(https://wikipapa.org/images/pisos-altitudinales-2000-3000.png)";
          break;
        case _adaptability_aux_2 < 4000:
          _adaptability_img =
            "url(https://wikipapa.org/images/pisos-altitudinales-3000-4000.png)";
          break;
        case _adaptability_aux_2 < 5000:
          _adaptability_img =
            "url(https://wikipapa.org/images/pisos-altitudinales-4000-mas.png)";
          break;
        default:
          _adaptability_img =
            "url(https://wikipapa.org/images/pisos-altitudinales-ori.png)";
      }

      const _adaptability = this.data.data_2.filter(
        (x: any) => x.descriptor_id == 46
      )[0]?.value;

      const _aditional_information = this.data.data_1.description;
      const _coordinate_list = this.data.data_5.map((x: Coordinates) => {
        return {
          latitude: x.latitude,
          longitude: x.longitude,
          location: x.location,
        };
      });

      const _cooking_time = this.data.data_3.filter(
        (x: any) => x.descriptor_id == 57
      )[0]?.value;

      const _culinary_uses = this.data.data_3.filter(
        (x: any) => x.descriptor_id == 58
      )[0]?.value;

      const _nutritional_list = this.data.data_4.map((x: any) => {
        const _descriptor_name_1 = x.descriptor_name.replace(
          "Concentracion de ",
          ""
        );
        const _descriptor_name_2 = _descriptor_name_1.replace(
          " en peso fresco",
          "\n(mg/100g)"
        );

        const _descriptor_name_3 = _descriptor_name_2.replace(
          "Porcentaje de ",
          ""
        );

        const _descriptor_name_4 = _descriptor_name_3.replace(
          "materia seca",
          "Materia seca \n(%)"
        );

        return { text_1: x.value, text_2: _descriptor_name_4 };
      });

      this.inputValuesUsesInformation = {
        adaptability: _adaptability ? _adaptability : "----",
        adaptability_img: _adaptability_img,
        aditional_information: _aditional_information,
        coordinate_list: _coordinate_list,
        cooking_time: _cooking_time,
        culinary_uses: _culinary_uses,
        nutritional_list: _nutritional_list,
      };

      if (_nutritional_list) {
        this.has_nutritional_list = _nutritional_list.length > 0 ? true : false;
      }

      if (_culinary_uses) {
        this.has_culinary_uses = _culinary_uses.length > 0 ? true : false;
      }

      if (_adaptability) {
        this.has_adaptability = _adaptability ? true : false;
      }

    }
  }

  fnSetInputTemplate() {
    switch (this.type) {
      case "descriptors_plant":
        const _image_plant = this.images.filter(
          (x: any) => x.category == "plant"
        )[0]?.image_url;

        this.inputTemplate = {
          main_icon: "spa",
          main_title: "DESCRIPCIÓN MORFOLÓGICA",
          title: "PLANTA",
          color: "#f6f3f6",
          image: _image_plant ? "url(" + _image_plant + ")" : false,
          info_list: this.data.map((x: Info) => {
            return { descriptor_name: x.descriptor_name, value: x.value };
          }),
        };

        break;

      case "descriptors_flower":
        const _image_flower = this.images.filter(
          (x: any) => x.category == "flower"
        )[0]?.image_url;

        this.inputTemplate = {
          main_icon: false,
          main_title: false,
          title: "FLOR",
          color: "#f6f3f6",
          image: _image_flower ? "url(" + _image_flower + ")" : false,
          info_list: this.data.map((x: Info) => {
            return { descriptor_name: x.descriptor_name, value: x.value };
          }),
        };

        break;

      case "descriptors_tuber":
        const _image_tuber = this.images.filter(
          (x: any) => x.category == "tuber"
        )[0]?.image_url;

        this.inputTemplate = {
          main_icon: false,
          main_title: false,
          title: "TUBERCULO",
          color: "#f6f3f6",
          image: _image_tuber ? "url(" + _image_tuber + ")" : false,
          info_list: this.data.map((x: Info) => {
            return { descriptor_name: x.descriptor_name, value: x.value };
          }),
        };

        break;

      case "descriptors_agronomy":
        this.inputTemplate = {
          main_icon: "description",
          main_title: "CARACTERÍSTICAS AGRONÓMICAS",
          title: false,
          color: "#ffeeed",
          image: false,
          info_list: this.data.map((x: Info) => {
            return { descriptor_name: x.descriptor_name, value: x.value };
          }),
        };

        break;

      default:
        break;
    }
  }


  fnGoGenotype() {
    const _url = this.myAngularxQrCode;
    if (_url) {
      window.open(_url, "_blank");
    }

  }

  fnGoToView(_route: string, _user_id: string, _username: string) {
    const _params = {
      p_user_id: _user_id,
      p_username: _username
    };

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_route], {
        queryParams: _params
      }).then(() => {
      });
    });
  }





  fnGoObs(id: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/observacion", id]).then(() => {
      })
    })
  }


  fnGoObsVar(_variety_name: string) {
    const _params = {
      p_any_date: true,
      p_variety_name: _variety_name
    };

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/observaciones"], {
        queryParams: _params
      }).then(() => {
      });
    });
  }


  // http://localhost:4200/observacion/4502


}
